export enum Dispositivo {
  MOBILE,
  IPAD,
  TABLET,
  DESKTOP
}
